export const SEARCH = "/search";
export const DASHBOARD = "/dashboard";
export const COLLECTIONS = "/collections";
export const COLLECTION = `${COLLECTIONS}/:collectionCode`;
